// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "-" + {"275":"5e9f4131","865":"8d02d1d4"}[chunkId] + ".css";
};